import i18n from '../../../common/i18n';

export function empty(emptyErrorKey) {
    return value => (!value ? i18n(emptyErrorKey) : null);
}

export function pattern(pattern, errorKey) {
    return (value = '') => {
        if (value === '') {
            return null;
        }
        return pattern.test(value) ? null : i18n(errorKey);
    };
}
